// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3EHhC","colCheckbox":"styles_colCheckbox__1AwXt"};